var paragraph_default = {
  "fontElementMap": "EUIbB",
  "elementSpacing": "Ki7IH",
  "text": "MzdCO Ki7IH",
  "child": "Ff5xF"
};
export {
  paragraph_default as default
};
//# sourceMappingURL=paragraph-scss.js.map
